/* esm.sh - applesauce-common@5.2.0/helpers/blossom */
export * from "/*applesauce-common@5.2.0/esnext/helpers/blossom.mjs";
